import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

const API = `${process.env.REACT_APP_API_URL}/api`;

export default function Maintenance() {
  const { t } = useTranslation();
  const [processing, setProcessing] = useState(false);
  const [bypassError, setBypassError] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/system/status`, { withCredentials: true })
      .then((res) => {
        if (!mounted) return;
        const maintenanceMessage = String(res?.data?.message || "").trim();
        setMessage(maintenanceMessage);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    const params = new URLSearchParams(window.location.search);
    const key = (params.get("key") || "").trim();

    if (!key) return undefined;

    const clearTokenFromUrl = () => {
      if (window.location.pathname === "/maintenance" && window.location.search) {
        window.history.replaceState({}, "", "/maintenance");
      }
    };

    const runBypass = async () => {
      setProcessing(true);
      setBypassError(false);
      try {
        const res = await axios.post(
          `${API}/system/bypass`,
          { token: key },
          { withCredentials: true },
        );

        clearTokenFromUrl();

        if (res?.data?.valid) {
          window.location.href = "/dashboard";
          return;
        }

        if (!mounted) return;
        setBypassError(true);
        setProcessing(false);
      } catch {
        if (!mounted) return;
        clearTokenFromUrl();
        setBypassError(true);
        setProcessing(false);
      }
    };

    runBypass();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center px-4 py-10" data-testid="maintenance-page">
      <section className="w-full max-w-xl rounded-md border border-border bg-card p-8 text-center">
        <div className="mx-auto mb-4 w-14 h-14 rounded-md border border-brand-primary/30 bg-brand-primary/10 flex items-center justify-center">
          <ShieldAlert className="w-7 h-7 text-brand-primary" />
        </div>

        <p className="inline-flex text-[10px] font-mono uppercase tracking-widest px-2.5 py-1 rounded-sm border border-brand-primary/30 bg-brand-primary/10 text-brand-primary">
          {t("maintenance.badge", { defaultValue: "Maintenance Mode" })}
        </p>

        <h1 className="font-heading text-2xl md:text-3xl font-bold tracking-tight mt-4">
          {t("maintenance.title", { defaultValue: "Sistem Sedang Dalam Pemeliharaan" })}
        </h1>

        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
          {message ||
            t("maintenance.desc", {
              defaultValue:
                "Kami sedang melakukan peningkatan sistem. Silakan coba lagi beberapa saat.",
            })}
        </p>

        {processing && (
          <p className="mt-4 text-sm text-brand-primary">
            {t("maintenance.validating", { defaultValue: "Memverifikasi akses..." })}
          </p>
        )}

        {bypassError && (
          <p className="mt-4 text-sm text-verdict-fake">
            {t("maintenance.tokenInvalid", { defaultValue: "Akses tidak diizinkan." })}
          </p>
        )}

      </section>
    </main>
  );
}
